import { ContentContainer, TablePageShell } from '@urbantxt/layout';
import React, { useCallback, useMemo } from 'react';
import { Tabs } from 'rsuite';
import { useSearchParams } from 'react-router-dom';
import { useCanWriteRule } from 'access/usePermission';

import DocumentsTab from '../components/DocumentsTab/DocumentsTab';
import AiFlowTab from '../components/AiFlowTab/AiFlowTab';

export type BagelConfigTab = 'documents' | 'flow';

function parseBagelConfigTab(value: string | null): BagelConfigTab {
  if (value === 'flow' || value === 'prompts') return 'flow';
  return 'documents';
}

export default function BagelConfigPage() {
  const canEdit = useCanWriteRule('bagel-config');
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = useMemo(
    () => parseBagelConfigTab(searchParams.get('tab')),
    [searchParams],
  );

  const handleTabSelect = useCallback(
    (key: string | number | undefined) => {
      const tab = parseBagelConfigTab(
        typeof key === 'string' ? key : null,
      );
      setSearchParams(
        prev => {
          const next = new URLSearchParams(prev);
          if (tab === 'flow') {
            next.set('tab', 'flow');
          } else {
            next.delete('tab');
          }
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return (
    <TablePageShell>
      <ContentContainer title="Bagel AI Config">
        <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
          <Tabs.Tab eventKey="documents" title="Documents">
            <DocumentsTab readOnly={!canEdit} />
          </Tabs.Tab>
          <Tabs.Tab eventKey="flow" title="AI Flow">
            <AiFlowTab readOnly={!canEdit} />
          </Tabs.Tab>
        </Tabs>
      </ContentContainer>
    </TablePageShell>
  );
}
